import React from 'react';
import cl from './HomeInfo.module.css';
import { NavLink } from 'react-router-dom';
import Sale from '../../../image/sale.png';

const HomeInfo = (props) => {
  return (
    <section className={cl.about}>
      {/* <NavLink className={cl.link_image} to='/news'>
            <img className={cl.big_image} src='https://img.freepik.com/fotos-gratis/conceito-de-simbolos-de-icones-de-comunicacao-de-tecnologia_53876-120314.jpg'/>
          </NavLink> */}
      <NavLink className={cl.link_image} to="/products">
        <div className={cl.sale_image}>
          <span>Discounts up to -90%</span>
        </div>
        {/* <img
          className={cl.big_image}
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTdfxEPTjWUPjDy30pb2W_QLZRk9Q7Naxd78AvZKCWqVYO8wjZqyT0Xd33leSBPiAlGYh4&usqp=CAU"
        /> */}
      </NavLink>
      <NavLink className={cl.link_image} to="/about">
        <img
          className={cl.big_image}
          src="https://www.bkacontent.com/wp-content/uploads/2020/06/Depositphotos_114292702_l-2015.jpg"
        />
      </NavLink>
    </section>
  );
};

export default HomeInfo;
